import { render, staticRenderFns } from "./ZephrPasswordResetPage.vue?vue&type=template&id=075bea4a"
import script from "./ZephrPasswordResetPage.vue?vue&type=script&lang=js"
export * from "./ZephrPasswordResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports